import { useEffect, useRef } from 'react';
import { createPortal } from 'react-dom';
import { FiX } from 'react-icons/fi';

import { PasswordForm } from '../../pages/admin/components/PasswordForm';
import styles from './styles.module.scss';

interface IProps {
  onClose: () => void;
}

export const ChangePasswordModal = ({ onClose }: IProps) => {
  const closeButtonRef = useRef<HTMLButtonElement>(null);

  useEffect(() => {
    closeButtonRef.current?.focus();

    const handleKeyDown = (e: KeyboardEvent) => {
      if (e.key === 'Escape') {
        onClose();
      }
    };

    document.addEventListener('keydown', handleKeyDown);
    return () => document.removeEventListener('keydown', handleKeyDown);
  }, [onClose]);

  return createPortal(
    <div className={styles.overlay} onClick={onClose} role="presentation">
      <div
        className={styles.content}
        role="dialog"
        aria-modal="true"
        aria-label="Alterar minha senha"
        onClick={(e) => e.stopPropagation()}
      >
        <button
          ref={closeButtonRef}
          type="button"
          className={styles.closeButton}
          onClick={onClose}
          aria-label="Fechar"
        >
          <FiX size={20} />
        </button>
        <h2 className={styles.title}>Alterar minha senha</h2>
        <PasswordForm onClose={onClose} />
      </div>
    </div>,
    document.body
  );
};
